module.exports = __webpack_public_path__ + "static/toggl-video-placeholder-c5576779155581598bae6a03500a9dc4.jpg";